import { render, staticRenderFns } from "./JdGoodsPriceAdjustDialog.vue?vue&type=template&id=02d71806"
import script from "./JdGoodsPriceAdjustDialog.vue?vue&type=script&lang=js"
export * from "./JdGoodsPriceAdjustDialog.vue?vue&type=script&lang=js"
import style0 from "./JdGoodsPriceAdjustDialog.vue?vue&type=style&index=0&id=02d71806&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02d71806')) {
      api.createRecord('02d71806', component.options)
    } else {
      api.reload('02d71806', component.options)
    }
    module.hot.accept("./JdGoodsPriceAdjustDialog.vue?vue&type=template&id=02d71806", function () {
      api.rerender('02d71806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jdStore/jdSkuList/components/JdGoodsPriceAdjustDialog.vue"
export default component.exports